import Col from "antd/es/col";
import Row from "antd/es/row";
import TextWithIcon from "common/Text/TextWithIcon";
import { ICON_TYPES } from "@shared/common/constants";
import { typography } from "@shared/common/Themes/typography";
import React from "react";
import styled, { useTheme } from "styled-components";
import Text from "common/Typography/Text";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import {
  EXCHANGE_ICON_MARGIN,
  EXCHANGE_ICON_SIZE,
  USD_PRECISION,
} from "@shared/features/onboarding/constants";
import { MainCoinProps } from "@shared/features/onboarding/types";
import { toFixed } from "@shared/utils/numbers";

const MainCoin = ({ coinData, spans, isRadio }: MainCoinProps) => {
  const appTheme = useTheme();
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const shiftingDistance = isRadio
    ? 0
    : EXCHANGE_ICON_SIZE + EXCHANGE_ICON_MARGIN;

  return (
    <Row>
      <Col
        span={spans[0]}
        style={{
          transform: `translate(${shiftingDistance}px, 0)`,
          paddingRight: shiftingDistance,
        }}
      >
        <TextWithIcon
          text={coinData.coin}
          iconType={ICON_TYPES.COIN}
          coinOrExchangeName={coinData.coin}
          iconSize={"m"}
          textStyle={{
            fontSize: typography.fontSizes.S,
            color: appTheme.colors.primaryText,
          }}
          iconStyle={{ margin: "0 4px 2px 0" }}
        />
      </Col>
      <Col span={spans[1]}>
        <StyledText>
          {coinData.numOfSignals} ({coinData.signalsPercentage}%)
        </StyledText>
      </Col>
      <StyledCol span={spans[2]} $isMobile={isMobile}>
        <StyledText>{toFixed(coinData.total, USD_PRECISION)} USD</StyledText>
        <StyledText style={{ marginLeft: 4 }}>
          ({toFixed(coinData.available, USD_PRECISION)} USD)
        </StyledText>
      </StyledCol>
    </Row>
  );
};

export default MainCoin;

const StyledText = styled(Text).attrs({ type: "secondary" })`
  font-size: ${(p) => p.theme.typography.fontSizes.S};
`;
const StyledCol = styled(Col)<{ $isMobile: boolean }>`
  display: flex;
  justify-content: end;
  text-align: end;
  flex-direction: ${(p) => (p.$isMobile ? "column" : "row")};
`;
